/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Box,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrintIcon from "@material-ui/icons/Print";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import "moment/locale/th";
import { FinanceBudgetService } from "_services/financebudget.service";
import BudgetReportPrintModal from "./BudgetReportPrintModal";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: theme.spacing(3)
  },
  tableHeadCell: {
    backgroundColor: "#1e3a8a",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  subHeadCell: {
    backgroundColor: "#0284c7",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  sumRow: {
    backgroundColor: "#f1f5f9",
    fontWeight: "bold"
  }
}));

const getCurrentFiscalYear = () => {
  const now = moment();
  return (now.month() >= 9 ? now.year() + 543 + 1 : now.year() + 543).toString();
};

export default function BudgetReports() {
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [printModalOpen, setPrintModalOpen] = useState(false);

  // Filter params
  const [year, setYear] = useState(() => getCurrentFiscalYear());
  const [years, setYears] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Report data states
  const [paidItems, setPaidItems] = useState([]);
  const [pendingItems, setPendingItems] = useState([]);
  const [activitySummary, setActivitySummary] = useState([]);
  const [categorySummary, setCategorySummary] = useState([]);

  useEffect(() => {
    FinanceBudgetService.getYears().then(res => {
      if (res.data.success) {
        setYears(res.data.data);
        if (res.data.data.length > 0 && !year) setYear(res.data.data[0].value);
      }
    });
  }, []);

  useEffect(() => {
    loadActiveReport();
  }, [activeTab, year]);

  const loadActiveReport = async () => {
    setLoading(true);
    try {
      if (activeTab === 0) {
        const res = await FinanceBudgetService.getPaidReport(
          year,
          null,
          fromDate || null,
          toDate || null
        );
        if (res.data.success) setPaidItems(res.data.data);
      } else if (activeTab === 1) {
        const res = await FinanceBudgetService.getPendingReport(
          year,
          null,
          fromDate || null,
          toDate || null
        );
        if (res.data.success) setPendingItems(res.data.data);
      } else if (activeTab === 2) {
        const res = await FinanceBudgetService.getActivityReport(year);
        if (res.data.success) setActivitySummary(res.data.data);
      } else if (activeTab === 3) {
        const res = await FinanceBudgetService.getCategoryReport(year);
        if (res.data.success) setCategorySummary(res.data.data);
      }
    } catch (err) {
      console.error("Load report error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    setPrintModalOpen(true);
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <TextField
                select
                label="ปีงบประมาณ"
                fullWidth
                size="small"
                variant="outlined"
                value={year}
                onChange={e => setYear(e.target.value)}
              >
                {years.map(y => (
                  <MenuItem key={y.value} value={y.value}>
                    {y.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {activeTab <= 1 && (
              <>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="ตั้งแต่วันที่"
                    type="date"
                    fullWidth
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="ถึงวันที่"
                    type="date"
                    fullWidth
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={3} style={{ display: "flex", gap: "8px" }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                onClick={loadActiveReport}
              >
                ดึงรายงาน
              </Button>
              <Button
                variant="outlined"
                color="default"
                startIcon={<PrintIcon />}
                onClick={handlePrint}
              >
                พิมพ์
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Paper className={classes.card}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="1. ใบกันเบิกจ่ายแล้ว" />
          <Tab label="2. ใบกันยังไม่เบิกจ่าย" />
          <Tab label="3. สรุปตามกิจกรรม" />
          <Tab label="4. สรุปตามหมวดหมู่ค่าใช้จ่าย" />
        </Tabs>

        <Box p={2}>
          {loading ? (
            <Box p={4} textAlign="center">
              <CircularProgress />
              <Typography style={{ marginTop: 16 }}>
                กำลังประมวลผลรายงาน...
              </Typography>
            </Box>
          ) : activeTab === 0 ? (
            /* Report 1: ใบกันเบิกจ่ายแล้ว */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานใบกันเงินที่เบิกจ่ายแล้ว (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      เลขที่ใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      โครงการ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      หมวดจัดซื้อ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      บริษัท/ผู้ขาย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center">
                      ลงวันที่
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center">
                      วันที่เบิกจ่าย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดเบิกจ่าย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      คืนโครงการ
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paidItems.length > 0 ? (
                    paidItems.map((item, idx) => (
                      <TableRow key={item.id} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          {item.number}
                        </TableCell>
                        <TableCell>{item.projectName || "-"}</TableCell>
                        <TableCell>{item.categoryName || "-"}</TableCell>
                        <TableCell>{item.companyName || "-"}</TableCell>
                        <TableCell align="center">
                          {item.kDate
                            ? moment(item.kDate)
                                .add(543, "years")
                                .format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="center">
                          {item.datePay
                            ? moment(item.datePay)
                                .add(543, "years")
                                .format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {item.protectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ color: "#16a34a", fontWeight: "bold" }}
                        >
                          {item.payMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#0284c7" }}>
                          {item.diffRefund.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูลในรอบนี้
                      </TableCell>
                    </TableRow>
                  )}
                  {paidItems.length > 0 && (
                    <TableRow className={classes.sumRow}>
                      <TableCell colSpan={7} align="right">
                        รวมทั้งสิ้น ({paidItems.length} รายการ):
                      </TableCell>
                      <TableCell align="right">
                        {paidItems
                          .reduce((acc, c) => acc + c.protectMoney, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right" style={{ color: "#16a34a" }}>
                        {paidItems
                          .reduce((acc, c) => acc + c.payMoney, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right" style={{ color: "#0284c7" }}>
                        {paidItems
                          .reduce((acc, c) => acc + c.diffRefund, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : activeTab === 1 ? (
            /* Report 2: ใบกันยังไม่เบิกจ่าย */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานใบกันเงินที่ยังไม่เบิกจ่าย / คงค้าง (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      เลขที่ใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      โครงการ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      หมวดจัดซื้อ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      บริษัท/ผู้ขาย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center">
                      ลงวันที่
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      เบิกจ่ายแล้วบางส่วน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดคงค้างรอเบิก
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingItems.length > 0 ? (
                    pendingItems.map((item, idx) => (
                      <TableRow key={item.id} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell
                          style={{ fontWeight: "bold", color: "#1e3a8a" }}
                        >
                          {item.number}
                        </TableCell>
                        <TableCell>{item.projectName || "-"}</TableCell>
                        <TableCell>{item.categoryName || "-"}</TableCell>
                        <TableCell>{item.companyName || "-"}</TableCell>
                        <TableCell align="center">
                          {item.kDate
                            ? moment(item.kDate)
                                .add(543, "years")
                                .format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {item.protectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#0284c7" }}>
                          {item.totalPaidSoFar.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ color: "#dc2626", fontWeight: "bold" }}
                        >
                          {item.pendingBalance.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่มีรายการคงค้างรอเบิกจ่าย
                      </TableCell>
                    </TableRow>
                  )}
                  {pendingItems.length > 0 && (
                    <TableRow className={classes.sumRow}>
                      <TableCell colSpan={6} align="right">
                        รวมทั้งสิ้น ({pendingItems.length} รายการ):
                      </TableCell>
                      <TableCell align="right">
                        {pendingItems
                          .reduce((acc, c) => acc + c.protectMoney, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right">
                        {pendingItems
                          .reduce((acc, c) => acc + c.totalPaidSoFar, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right" style={{ color: "#dc2626" }}>
                        {pendingItems
                          .reduce((acc, c) => acc + c.pendingBalance, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : activeTab === 2 ? (
            /* Report 3: สรุปตามกิจกรรม */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานสรุปงบประมาณแยกตามกิจกรรม (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.subHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.subHeadCell}>
                      กิจกรรม
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="center">
                      จำนวนใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดกันเงินรวม (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเบิกจ่ายแล้ว (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดคงเหลือรอเบิก (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activitySummary.length > 0 ? (
                    activitySummary.map((item, idx) => (
                      <TableRow key={item.aid} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>
                          {item.activityName}
                        </TableCell>
                        <TableCell align="center">
                          {item.protectCount}
                        </TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                          {item.totalProtectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#16a34a" }}>
                          {item.totalPaidMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#dc2626" }}>
                          {item.totalPendingMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูล
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : (
            /* Report 4: สรุปตามหมวดหมู่ */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานสรุปงบประมาณแยกตามหมวดหมู่ค่าใช้จ่าย (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.subHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.subHeadCell}>
                      หมวดหมู่ค่าใช้จ่าย
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="center">
                      จำนวนรายการ
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเงินกันรวม (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเบิกจ่ายแล้ว (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categorySummary.length > 0 ? (
                    categorySummary.map((item, idx) => (
                      <TableRow key={item.cid} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>
                          {item.categoryName}
                        </TableCell>
                        <TableCell align="center">
                          {item.protectCount}
                        </TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                          {item.totalProtectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#16a34a" }}>
                          {item.totalPaidMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูล
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </Box>
      </Paper>

      {/* A4 Print Preview Modal */}
      <BudgetReportPrintModal
        open={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        reportType={activeTab}
        year={year}
        fromDate={fromDate}
        toDate={toDate}
        data={
          activeTab === 0
            ? paidItems
            : activeTab === 1
            ? pendingItems
            : activeTab === 2
            ? activitySummary
            : categorySummary
        }
      />
    </div>
  );
}
